export default __webpack_public_path__ + "static/media/offer_pay_2_mobile.9730b6a7.gif";